const emptyAdditionalSupportedNetworks = {
    asSource: [],
    withdrawal: [],
    autofill: [],
};
export function computeEvmNetworkBuckets(networks, networkAdapter, additionalSupportedNetworks = emptyAdditionalSupportedNetworks) {
    const asSource = [
        ...networks
            .filter(network => networkAdapter.isEvmNetwork(network))
            .map(network => networkAdapter.getId(network)),
        ...additionalSupportedNetworks.asSource,
    ];
    const withdrawal = [
        ...asSource,
        ...additionalSupportedNetworks.withdrawal,
    ];
    const autofill = [
        ...withdrawal,
        ...additionalSupportedNetworks.autofill,
    ];
    return { asSource, withdrawal, autofill };
}
